/**
 * Search columns definition for customer search
 */
export const customerSearchColsDefinition = [
  {
    field: 'customer_code',
    headerName: 'Mã đối tượng',
    width: 120
  },
  {
    field: 'customer_name',
    headerName: 'Tên đối tượng',
    width: 200
  },
  {
    field: 'credit_limit',
    headerName: 'Công nợ p/thu',
    width: 120
  },
  { field: 'credit_limit', headerName: 'Công nợ p/trả', width: 120 },
  { field: 'tax_code', headerName: 'Mã số thuế', width: 120 },
  { field: 'email', headerName: 'Email', width: 150 },
  { field: 'phone', headerName: 'Số điện thoại', width: 120 }
];

/**
 * Search columns definition for payment days
 */
export const paymentDaySearchCols = [
  { field: 'ma', headerName: 'Mã', width: 120 },
  { field: 'ten', headerName: 'Tên', width: 200 }
];
